import React from "react";
import { Helmet } from "react-helmet";

export default function NotFound() {
  return (
    <React.Fragment>
      <Helmet>
        <title>404 :(</title>
      </Helmet>
      <div className="not-found">
        <h1>404</h1>
        <h2>Document not found</h2>
        <p>
          <a href="/">Return to homepage</a>
        </p>
      </div>
    </React.Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/NotFound.js